// 加盟店種別登録・更新のラベル
export const LABELS = {
  REGISTER_TITLE: "加盟店種別登録・更新",
  APPLICABLE_START_DATE: "適用開始日",
  TYPE_NO: "種別No",
  TYPE_NAME: "種別名",
  ADDRESS_MANAGEMENT: "住所管理要否",
  STORE_INFO_AGGREGATION_TARGET: "店舗情報集約",
  FAKE_INDUSTRY_CHECK: "偽業態チェック",
  STORE_APPLICATION_FORM: "店舗申請様式",
  TENANT_EXAMINATION: "店子審査要否",
  TENANT_EXAMINATION_UNIT: "店子審査単位",
  NECESSARY: "要",
  UNNECESSARY: "不要",
  TARGET: "対象",
  NOT_TARGET: "対象外",
  STORE_SETTING: "店舗関連設定",
  REVIEW_SETTING: "審査関連設定",
  COMMENT: "コメント",
  LATEST_COMMENT: "最終コメント",
  SHOW_COMMERCIAL_APPLICATION_INFO: "商用反映済情報",
  COMMERCIAL_APPLICATION_INFO: "商用反映済情報",
  LAST_UPDATE_AT: "最終更新者:",
  LAST_UPDATE_BY: "最終更新日:",
  LAST_ACTION_AT: "最終承認者:",
  LAST_ACTION_BY: "最終承認日:",
  TENANT_EXAMINATION_UNIT_ITEM_MESSAGE: "店子審査要否が要の場合必須",
  COMMENT_ITEM_MESSAGE: "差戻しの場合必須",
};
